var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TedsLauncherTopBar"},[_c('div',{staticClass:"search-section"},[_c('teds-launcher-global-search')],1),_c('div',{staticClass:"profile-section"},[_c('teds-launcher-profile-section')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }